module.exports = __webpack_public_path__ + "static/img/5.1c87b10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/sp/5.png
// module id = 7bun
// module chunks = 0